import type React from "react";
import { UtensilsIcon, PillIcon, BarChartIcon, ChatBubbleIcon } from "../../icons.js";
import type { WidgetProps } from "../types.js";

function LaunchButton({
  Icon, label, onClick,
}: {
  Icon: React.ComponentType<{ size?: number; className?: string }>;
  label: string;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      className="flex items-center gap-2 rounded-lg border border-gray-200 dark:border-gray-800 px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800"
    >
      <Icon size={16} className="text-(--accent)" />
      {label}
    </button>
  );
}

export function QuickLogWidget({ onNavigate }: WidgetProps) {
  return (
    <section className="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 p-4">
      <h2 className="mb-2 font-semibold text-gray-900 dark:text-gray-100">Quick log</h2>
      <div className="grid grid-cols-2 gap-2">
        <LaunchButton Icon={UtensilsIcon}   label="Food"          onClick={() => onNavigate("food")} />
        <LaunchButton Icon={PillIcon}       label="Medications"   onClick={() => onNavigate("regimens")} />
        <LaunchButton Icon={BarChartIcon}   label="Charts"        onClick={() => onNavigate("charts")} />
        <LaunchButton Icon={ChatBubbleIcon} label="More in chat"  onClick={() => onNavigate("chat")} />
      </div>
    </section>
  );
}
